import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
// eslint-disable-next-line unused-imports/no-unused-imports
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab, { createDocsTab } from "../Components/DocPage/new-tab/page-docs-tab";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import EmploymentMain from "../Components/EmploymentPage/EmploymentMain";
import WageLossTab from "../Components/EmploymentPage/new-employment-page/wage-loss-tab";
import EmploymentModal from "../Components/EmploymentPage/components/EmploymentModal";
import { useGetStates } from "../Components/EmploymentPage/new-employment-page/hooks/useGetStates";
import { useGetEmploymentData } from "../Components/EmploymentPage/new-employment-page/hooks/useGetEmploymentData";
import EditEmploymentModal from "../Components/EmploymentPage/components/EditEmploymentModal";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import addIconGold from "../assets/Add-icon-gold.svg";
import HistoryTab from "../Components/EmploymentPage/new-employment-page/history-tab";
import EmploymentDatesModal from "../Components/EmploymentPage/new-employment-page/modals/show-history-modal";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";
import { api_without_cancellation } from "../api/api";
import { useGetHistoryData } from "../Components/EmploymentPage/new-employment-page/hooks/useGetHistoryData";

const PageContent = ({
  currentPage,
  employmentData,
  onEdit,
  setShow,
  historyData,
  pageName,
  pageIcon,
}) => {
  switch (currentPage) {
    // Employment MainTab use it for previous work
    case "wageloss":
      return <WageLossTab employmentData={employmentData} onEdit={onEdit} setShow={setShow} />;
    // case "disability":
    //   return <DisabilityTab employmentData={employmentData} onEdit={onEdit} />;
    case "history":
      return <HistoryTab history={historyData} />;
    case "photo":
      return <PhotoTab pageId={12} pageName={"Work"} />;
    case "docs":
      return (
        <PageDocsTab
          key={`${getClientId()}-${getCaseId()}`}
          pageId={12}
          pageName={pageName}
          pageIcon={pageIcon}
        />
      );
    default:
      return null;
  }
};

const EmploymentPage = () => {
  const [currentPage, setCurrentPage] = useState("wageloss");
  const isMediaPage = currentPage === "docs" || currentPage === "photo";
  const [show, setShow] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedEmployment, setSelectedEmployment] = useState(null);
  const [currentEditSection, setCurrentEditSection] = useState("employment");
  const { states } = useGetStates();
  const { employmentData, refetch: handleEmploymentAddedOrEdited } = useGetEmploymentData();
  const { historyData, refetch } = useGetHistoryData();
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);
  const [isDummy, setIsDummy] = useState(false);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 12).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const fetchDummyStatus = async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/general/panel_page_block/?case_id=${getCaseId()}&page_id=${12}`
      );
      setIsDummy(response?.data?.status);
    } catch (error) {
      console.error("Error fetching dummy status:", error);
    }
  };

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  useEffect(() => {
    fetchDummyStatus();
  }, []);

  const handleEditModalShow = (employment, section) => {
    setSelectedEmployment(employment);
    setCurrentEditSection(section);
    setShowEditModal(true);
  };

  const mainTabs = useMemo(
    () => [
      {
        id: "wageloss",
        label: "Wage Losses",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("wageloss"),
        leftHand: false,
      },
      {
        id: "history",
        label: "History",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("history"),
        leftHand: false,
      },
      // {
      //   id: "disability",
      //   label: "Disability",
      //   className: "tab-trapezium-cycles-corners",
      //   background: "var(--primary-5)",
      //   activeColor: "white",
      //   onClick: () => handlePageChange("disability"),
      //   leftHand: false,
      // },
    ],
    [handlePageChange]
  );

  const actionTabs = useMemo(
    () =>
      [
        currentPage === "wageloss" && {
          id: "add-employment",
          label: "Employment",
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          left: "0px",
          onClick: () => setShow(true),
          leftHand: true,
          span: (
            <span className="fw-bold ic-15 d-flex align-items-center">
              <img src={addIconGold} alt="" />
            </span>
          ),
        },

        currentPage === "history" && {
          id: "add-history",
          label: "Employment Dates",
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          left: "0px",
          onClick: () => {
            setShowHistory(true);
          },
          leftHand: true,
          span: (
            <span className="fw-bold ic-15 d-flex align-items-center">
              <img src={addIconGold} alt="" />
            </span>
          ),
        },
      ].filter(Boolean),
    [currentPage]
  );

  const photoTabs = useMemo(
    () => [
      createDocsTab(() => handlePageChange("docs")),
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(12, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 12, dispatch);
  }, [dispatch]);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="12" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <div className="d-flex align-items-center">
              <SmartResponsiveTabsContainer
                isEmpty={isDummy || employmentData?.length === 0}
                HandlePage={currentPage}
                tabsData={mainTabs}
                viewTab={[]}
                addTab={actionTabs}
                photoTab={attachmentTabs}
                photoTabControlled={true}
                handlePageChange={handlePageChange}
                viewType={""}
              />
            </div>
            {isDummy && !isMediaPage ? (
              <>
                <PlaceHolderifNothingAdded
                  text1={"No Employers on the Case"}
                  text2={"Page is Marked Complete"}
                  text3={"To Add an Employer to the Case Click Here"}
                  pageIcon={pageObject?.page_icon}
                  completed
                  onClick={() => setShow(true)}
                />
              </>
            ) : employmentData?.length === 0 && !isMediaPage ? (
              <PlaceHolderifNothingAdded
                text1={"No Client Employment added"}
                text2={"Click to Add"}
                pageIcon={pageObject?.page_icon}
                onClick={() => setShow(true)}
              />
            ) : (
              <PageContent
                currentPage={currentPage}
                employmentData={employmentData}
                onEdit={handleEditModalShow}
                setShow={setShow}
                historyData={historyData}
                pageName={pageObject?.name}
                pageIcon={pageObject?.page_icon}
              />
            )}

            <NotesSectionDashboard pageName={"Notes"} />
          </div>
        </div>
      </div>

      <Footer />

      {show && (
        <EmploymentModal
          show={show}
          handleClose={() => setShow(false)}
          onFetchEmployment={() => {
            handleEmploymentAddedOrEdited();
            fetchDummyStatus();
          }}
          states={states}
          isDummy={isDummy}
        />
      )}

      {showEditModal && (
        <EditEmploymentModal
          show={showEditModal}
          object={selectedEmployment}
          section={currentEditSection}
          handleClose={() => setShowEditModal(false)}
          onFetchEmployment={handleEmploymentAddedOrEdited}
          states={states}
        />
      )}

      {showHistory && (
        <EmploymentDatesModal
          employers={employmentData}
          show={showHistory}
          onHide={() => setShowHistory(false)}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default EmploymentPage;
